<script>
import config from '../config'
export default {
  name: 'api-child-handler',
  created () {
    window.location = config.SERVER + '/' + (this.$route.params[0] || this.$route.params.pathMatch)
  }
}
</script>
